export default {"src":"/_next/static/media/background.a62577e9.svg","height":678,"width":684,"blurWidth":0,"blurHeight":0};